import * as ol from 'openlayers'
import { DataTheme } from 'src/Enums'
import { GeoLayer, AbstractLayer, AbstractLayerOptions, RadioSubLayer } from './Layer'
import { layerCopyrights, LayerDescription, LayerGroup, LayerParamsObject, LayerType } from './LayerRegistry'
import legendImage from '../../img/legend_soil_types.png'
import { ContextTag } from '../wiki/Wiki'

const defaultSubLayer: RadioSubLayer = {
  labelId: 'map.layer.soiltypes.sublayer.soiltypes200',
  subLayer: 'Jordart_200000',
  path: 'Jordartskort_200000'
}

/**
 * Map layer class for the Soil Type Maps WMS source from GEUS.
 */
class SoilTypesLayer extends AbstractLayer implements GeoLayer {
  static readonly defaultParams: LayerParamsObject = {
    opacity: 0.5,
    radioSubLayers: {
      labelId: 'layerpicker.radiosublayer.soiltypes',
      selected: defaultSubLayer,
      sublayers: [
        {
          labelId: 'map.layer.soiltypes.sublayer.soiltypes25',
          subLayer: 'Jordart_25000_uden_hav',
          path: 'Jordartskort_25000'
        },
        defaultSubLayer
      ]
    }
  }

  constructor (options: any) {
    const defaultOptions: AbstractLayerOptions = {
      layerType: LayerType.SOIL_TYPES,
      enabled: true,
      minZoom: 7,
      zIndex: 3
    }
    super({ ...defaultOptions, ...options })

    let { radioSubLayers, opacity } = options.params
    opacity = opacity === undefined ? SoilTypesLayer.defaultParams.opacity : opacity

    this.olLayer = new ol.layer.Image({
      visible: this.enabled,
      opacity: opacity,
      source: new ol.source.ImageWMS({
        url: `https://data.geus.dk/arcgis/services/Denmark/${radioSubLayers.selected.path as string}/MapServer/WmsServer`,
        params: {
          layers: radioSubLayers.selected.subLayer
        },
        projection: new ol.proj.Projection({
          code: 'EPSG:25832'
        }),
      })
    })
  }

  static describe (): LayerDescription {
    return {
      type: LayerType.SOIL_TYPES,
      name: 'map.layer.soiltypes',
      group: LayerGroup.NEAR_TERRAIN,
      contextTags: [
        ContextTag.SOIL_TYPES
      ],
      themes: Object.values(DataTheme),
      capabilitiesUrl: '',
      legendEnabled: true,
      imageLegend: {
        legendImage: legendImage,
        imageWidth: 210
      },
      opacityEnabled: true,
      layerCopyright: layerCopyrights.Geus
    }
  }
}

export default SoilTypesLayer